<template>
    <div>
        <swiper ref="childSwiper" v-if="swiperList.length" class="h-swiper" :options="swiperOption">
            <swiper-slide v-for="item in swiperList" :key="item.id">
                <img class="swiper-img" :src="item.imgUrl" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <span></span>
        </swiper>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
    components: {
        swiper,
        swiperSlide
    },
    data() {
        const that = this;
        return {
            swiperOption: {
                autoplay: 5000,
                loop: true,
                slidesPerView: 'auto',
                pagination: '.swiper-pagination',
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                observer: true,
                onSlideChangeStart(Swiper) {
                    that.currentIndex = Swiper.realIndex;
                    that.$store.commit('home/SET_SWIPER_INDEX', Swiper.realIndex);
                }
            },
            swiperList: []
        };
    },
    methods: {
        ...mapActions('home', [
            'queryBanner'
        ]),
        queryBanners() {
            this.queryBanner().then((res) => {
                if (res && res.code === 0) {
                    this.swiperList = res.data || [];
                }
            }, (err) => {
                console.log(err);
            });
        },
        slideChangeHandle(inx) {
            this.$refs.childSwiper.swiper.slideTo(inx);
        }
    },
    created() {
        this.queryBanners();
    }
};
</script>
<style lang="scss">
.h-swiper {
    .swiper-pagination-bullet {
        margin: 0 10px !important;
    }
    .swiper-pagination-bullet {
        opacity: 0.6;
    }
    .swiper-pagination-bullets {
        bottom: 30px;
    }
    .swiper-pagination-bullet {
        width: 16px;
        height: 16px;
        background-color: rgba(255, 255, 255, 0.4);
    }
    .swiper-pagination-bullet-active {
        background-color: #fff;
        opacity: 1;
    }
}
</style>
<style lang="scss" scoped>
.h-swiper {
    .swiper-img {
        display: block;
        width: 100%;
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/home/components/home-swiper.vue